module.exports = "images/nature_animal.8880df2cf75b38515804553285c7e228.png";